// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"23":"7d67845c","459":"ed18a616","706":"244f09d8"}[chunkId] + ".js";
};